class StringUtil {
  static providerName(provider) {
    if (provider) {
      return `${provider.last_name}, ${provider.first_name}${
        provider.credential ? ` | ${provider.credential}` : ''
      }`;
    }
    return '';
  }

  static b64toBlob(b64Data, contentType = '', sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  static numberForChart(number) {
    if (number > 0) {
      if (number > 1000) {
        return `${(Math.round(number / 100) / 10).toLocaleString()}k`;
      }
      return number;
    }
    return undefined;
  }

  static toTitleCase(str) {
    if (!str || typeof str !== 'string') {
      return str ?? '';
    }
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  static validateNPI(value) {
    if (!value) return null;

    if (!/^[12]\d{9}$/.test(value)) {
      return 'Please check your NPI Number. All NPI Numbers must start with a 1 or 2, and be exactly 10 digits.';
    }

    // Luhn check using CMS-specified "80840" prefix
    const digits = ('80840' + value).split('').map(Number);
    let sum = 0;
    for (let i = digits.length - 1; i >= 0; i--) {
      let d = digits[i];
      if ((digits.length - 1 - i) % 2 === 1) {
        d *= 2;
        if (d > 9) d -= 9;
      }
      sum += d;
    }
    if (sum % 10 !== 0) {
      return 'Please check your NPI Number. This number does not appear to be a valid NPI.';
    }

    return null;
  }
}

export { StringUtil };
export default StringUtil;
